import qs from 'query-string'
import clientEnv from 'utils/global/clientEnv'
import { generateRandomString } from 'domains/public/components/auth-service/utils/generateRandomString'
import {
  pkceStateKey,
  pkceCodeVerifierKey,
  authServiceClientId,
  redirectUri,
  responseType,
  scope,
  pkceCodeChallengeMethod,
} from 'domains/public/components/auth-service/utils/constants'
import { pkceChallengeFromVerifier } from 'domains/public/components/auth-service/utils/pkceChallengeFromVerifier'

export const redirectToAuthService = async (email: string) => {
  // Generate a random string for state param, which we store and then compare later once we get the response
  const state = generateRandomString()
  localStorage.setItem(pkceStateKey, state)

  // Generate a random string for pkce code verifier param, which we store and then send again when requesting token from code
  const codeVerifier = generateRandomString()
  localStorage.setItem(pkceCodeVerifierKey, codeVerifier)

  const codeChallenge = await pkceChallengeFromVerifier(codeVerifier)

  /* eslint-disable @typescript-eslint/naming-convention */
  const query = {
    state,
    scope,
    email,
    response_type: responseType,
    client_id: authServiceClientId,
    redirect_uri: redirectUri,
    code_challenge_method: pkceCodeChallengeMethod,
    code_challenge: codeChallenge,
  }
  /* eslint-enable @typescript-eslint/naming-convention */

  window.location.href = qs.stringifyUrl({
    url: `${clientEnv.PUBLIC_CLIENT_AUTH_SERVICE_BASE_URL}/oauth/authorize`,
    query,
  })
}
